import { createSlice } from "@reduxjs/toolkit";
import { GalleryInitialState } from "./types";
import { RootState } from "store/rootReducer";
import Axios from "axios";
import { API_URL } from "config";

const initialState: GalleryInitialState = {
  galleryItems: [],
  projectItemById: null,
  isLoading: false,
  hasError: false,
};

const gallery = createSlice({
  name: "drawerSlice",
  initialState,
  reducers: {
    setGalleryItems(state, action) {
      state.galleryItems = action.payload;
      state.isLoading = false;
    },
    setGalleryIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setGalleryHasError(state, action) {
      state.hasError = action.payload;
      state.isLoading = false;
    },
    setProjectItemById(state, action) {
      state.projectItemById = action.payload;
      state.isLoading = false;
    },
  },
});
export const {
  setGalleryItems,
  setGalleryIsLoading,
  setGalleryHasError,
  setProjectItemById,
} = gallery.actions;

export const selectGalleryItems = (state: RootState) =>
  state.gallery.galleryItems;
export const selectGalleryIsLoading = (state: RootState) =>
  state.gallery.isLoading;
export const selectGalleryHasError = (state: RootState) =>
  state.gallery.hasError;
export const selectProjectItemById = (state: RootState) =>
  state.gallery.projectItemById;

export const fetchGalleryItems = () => async (dispatch: any) => {
  dispatch(setGalleryIsLoading(true));
  try {
    const result = await Axios.get(`${API_URL}/projects`);
    dispatch(setGalleryItems(result.data.data));
  } catch (error: any) {
    console.log(error);
    dispatch(setGalleryHasError(true));
  }
};

export const fetchGalleryItemById = (id: string) => async (dispatch: any) => {
  dispatch(setGalleryIsLoading(true));
  try {
    const result = await Axios.get(`${API_URL}/projects/${id}`);
    dispatch(setProjectItemById(result.data.data));
  } catch (error: any) {
    console.log(error);
    dispatch(setGalleryHasError(true));
  }
};

export default gallery.reducer;
